import { Injectable } from '@angular/core'

import { ActiveSorting } from '../abstracts/table-base.abstract'
import { ActiveValidation } from '../components/branch-detail-base/branch-detail-base.component'
import { ValidatedAddress } from '../models/address.model'
import { AddressRepository } from '../repositories/address/address.repository'
import { Expression, Sorting } from '../repositories/base.repository'

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  public constructor(private readonly addressRepository: AddressRepository) {}

  public getFilter(
    sword: string,
    activeValidation: ActiveValidation,
    showOnlyConflicts: boolean
  ): Expression<ValidatedAddress>[] {
    const filter: Expression<ValidatedAddress>[] = []

    if (showOnlyConflicts) {
      filter.push({
        name: 'isResoluted',
        op: 'eq',
        val: false,
      })
    }
    if (sword) {
      filter.push(
        this.addressRepository.getSearchQuery(sword, [
          'plz',
          'place',
          'streetName',
          'houseNumber',
          'x',
          'y',
          'lat',
          'lon',
          'ags',
        ])
      )
    }
    if (activeValidation !== 'all') {
      filter.push({
        name: activeValidation,
        val: true,
        op: 'eq',
      })
    }
    return filter
  }

  public getSorting(activeSorting: ActiveSorting): Sorting[] | undefined {
    let sorting: Sorting[] | undefined = undefined

    if (activeSorting.length > 0) {
      sorting = activeSorting.map((sort) => ({
        property: sort.key,
        direction: sort.value === 'descend' ? 'des' : 'asc',
      }))
    }
    return sorting
  }
}
